// external
import type { Store } from 'redux';

// libraries
import { BaseMiddleware } from '@makemydeal/dr-activities-common';

// store
import type { Selectors } from './selectors';
import type { HostActions } from '../types/HostActions';
import { OPEN_RECENT_DEAL, REDIRECT_TO_DEAL_LIST, CREATE_QUOTE } from './actions';

export class MiddlewareManager extends BaseMiddleware {
    constructor(public selectors: Selectors, public hostActions: HostActions) {
        super(selectors);
    }

    /**
     * Any activity specific middleware code should be defined here;
     * application-specific middleware should be outside of the activity
     */
    protected middlewareFunction = (store: Store<any>, next: any, action: any): void => {
        switch (action.type) {
            case OPEN_RECENT_DEAL: {
                const { dealId, target } = action.payload;
                store.dispatch(this.hostActions.openDeal(dealId, target));
                break;
            }
            case REDIRECT_TO_DEAL_LIST: {
                store.dispatch(this.hostActions.redirectToDealList());
                break;
            }
            case CREATE_QUOTE: {
                store.dispatch(this.hostActions.createQuote(action.payload.coOrgId));
                break;
            }

            default: {
                break;
            }
        }
    };
}
